import {
  OccupationDetail,
  OccupationForExportPdf
} from '@cpd-app/core-module/models';

export const occupationDetailFeatureKey = 'occupationDetail';
export interface OccupationDetailState {
  occupationDetail: OccupationDetail | undefined;
  occupationForExportPdf: OccupationForExportPdf | undefined;
  /**
   * The last detail load that did not produce an occupation, and for which
   * page: 'not-found' when the API answered cleanly with nothing (a bad code
   * or job), 'error' when it failed. Keyed, so a failure on one page never
   * shows on another (code review, 30 Sep).
   */
  occupationLoadFailure: OccupationLoadFailure | null;
}

export interface OccupationLoadFailure {
  key: string;
  kind: 'not-found' | 'error';
}

/** The page a detail load is for: the code, and the job when there is one. */
export const occupationKey = (
  onetCode: string,
  jobId?: string | number | null
): string =>
  // A plain occupation carries jobId 0 or null in the detail and none in the
  // route; all three are the same page.
  `${onetCode}|${jobId ? String(jobId) : ''}`;

export const initialState: OccupationDetailState = {
  occupationDetail: undefined,
  occupationForExportPdf: undefined,
  occupationLoadFailure: null
};
